import React, { Suspense, lazy, useEffect, useState } from 'react';

const MkQrInner = lazy(() => import('./MkQrInner'));

/**
 * Desktop-only QR code. Renders nothing until mounted (so it never exists at ScrollReveal init and
 * never carries a reveal class), and nothing at all on phones. Hidden at ≤820px with CSS.
 */
const MkQr = ({ platform, value, title, caption }) => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    setReady(true);
  }, []);
  if (!ready || platform !== 'desktop') return null;
  return (
    <Suspense fallback={<div className="mk-qr__slot" />}>
      <MkQrInner value={value} title={title} caption={caption} />
    </Suspense>
  );
};

export default MkQr;
